import { render, staticRenderFns } from "./LessonPlansLogin.vue?vue&type=template&id=24a74752"
import script from "./LessonPlansLogin.vue?vue&type=script&lang=js"
export * from "./LessonPlansLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports